import type { GetterTree } from 'vuex'
import type { RootState } from 'store'
import type { SettingState } from './types'

export const getters: GetterTree<SettingState, RootState> = {
  settings: (state: SettingState) => state.settings,
}
